<template>
  <l-layout :layout="['xs12']" bottom-space>
    <v-layout justify-center>
      <v-flex xs12>
        <v-card class="pa-3">
          <v-form ref="vehicleForm">
            <v-layout column>
              <v-flex xs12>
                <v-select :items="vehicleForm.typeSelect"
                          :disabled="disabledFlag"
                          v-model="vehicleForm.type"
                          item-value="value" item-text="text"
                          prepend-icon="mdi-bus-clock"
                          :rules="[$rules.requiredS()]"
                          label="车辆类型"></v-select>
              </v-flex>
   <!--           <v-flex xs12 >
                <v-autocomplete
                  :disabled="disabledFlag"
                  v-show="vehicleForm.type==='org_ve'"
                  prepend-icon="$vuetify.icons.group"
                  :items="vehicleForm.groupSelects"
                  v-model="vehicleForm.group"
                  v-on:keyup="getGroups"
                  label="分组名称"
                  clearable
                  hide-details
                  hide-selected
                  item-text="name"
                  item-value="id"
                  :rule="[$rules.requiredS('必填')]"
                >
                  <template slot="no-data">
                    <v-alert :value="true" color="error">
                      暂无该用户组信息
                    </v-alert>
                  </template>
                  <template slot="item" slot-scope="props">
                    <v-list-tile-content>
                      <v-list-tile-title>
                        <v-flex row align-center justify-between>
                          <span>{{props.item.name}}</span>
                        </v-flex>
                      </v-list-tile-title>
                    </v-list-tile-content>
                    <v-list-tile-action>
                      <span class="grey&#45;&#45;text caption text-xs-right">{{props.item.code}}</span>
                    </v-list-tile-action>
                  </template>
                </v-autocomplete>
              </v-flex>-->
              <v-flex xs12>
                <LPlatePicker :disabled="disabledFlag"
                label="车辆号牌"
                v-model="vehicleForm.plate"></LPlatePicker>
              </v-flex>
              <v-flex xs12 v-if="hasSpecialPermission">
                <l-autocomplete
                  :init-data="false"
                  :get-data="searchUsers"
                  item-text="name"
                  label="车主选择"
                  item-sub-text="loginId"
                  prepend-icon="$vuetify.icons.person"
                  v-model="vehicleForm.driver"
                ></l-autocomplete>
              </v-flex>
              <v-layout column class="pl-4" v-if="vehicleForm.type==='per_ve'">
                <v-flex xs12>
                  <l-image v-if="vehicleForm.driverLicense.length === 0"></l-image>
                  <l-image-dialog
                    :src="img.src"
                    v-for="(img,i) in vehicleForm.driverLicense" :key="i">
                    <l-image
                      slot="activator"
                      :src="img.src"
                      :error="img.error"
                      :errorMessage="img.errorMessage"
                    >
                      <template slot="action">
                        <v-tooltip bottom>
                          <span>删除图像</span>
                          <v-btn slot="activator" @click="deleteImage(vehicleForm.driverLicense, i)" icon>
                            <v-icon>$vuetify.icons.delete</v-icon>
                          </v-btn>
                        </v-tooltip>
                      </template>
                    </l-image>
                  </l-image-dialog>
                </v-flex>
                <v-flex xs12>
                </v-flex>
                <v-flex xs12>
                  <l-select-file
                    @input="addFile(arguments[0], vehicleForm.driverLicense)"
                    file-type="image/*"
                    title="添加图片"
                  >
                    <v-btn color="primary" flat slot="activator" :disabled="vehicleForm.driverLicense.length===1||disabledFlag">
                      上传驾驶证<span class="error--text caption" >（至多只上传一张图片）</span>
                    </v-btn>
                  </l-select-file>
                </v-flex>
              </v-layout>
              <v-layout column class="pl-4" v-if="vehicleForm.type==='per_ve'">
                <v-flex xs12>
                  <l-image v-if="vehicleForm.vehicleLicense.length === 0"></l-image>
                  <l-image-dialog
                    :src="img.src"
                    v-for="(img,i) in vehicleForm.vehicleLicense" :key="i">
                    <l-image
                      slot="activator"
                      :src="img.src"
                      :error="img.error"
                      :errorMessage="img.errorMessage"
                    >
                      <template slot="action">
                        <v-tooltip bottom>
                          <span>删除图像</span>
                          <v-btn slot="activator" @click="deleteImage(vehicleForm.vehicleLicense, i)" icon>
                            <v-icon>$vuetify.icons.delete</v-icon>
                          </v-btn>
                        </v-tooltip>
                      </template>
                    </l-image>
                  </l-image-dialog>
                </v-flex>
                <v-flex xs12>
                  <l-select-file
                    @input="addFile(arguments[0], vehicleForm.vehicleLicense)"
                    file-type="image/*"
                    title="添加图片"
                  >
                    <v-btn color="primary" flat slot="activator" :disabled="vehicleForm.vehicleLicense.length===1||disabledFlag">
                      上传行驶证<span class="error--text caption" >（至多只上传一张图片）</span>
                    </v-btn>
                  </l-select-file>
                </v-flex>
              </v-layout>
              <v-layout column class="pl-4" v-if="vehicleForm.type==='per_ve'">
                <v-flex xs12>
                  <l-image v-if="vehicleForm.otherImage.length === 0"></l-image>
                  <l-image-dialog
                    :src="img.src"
                    v-for="(img,i) in vehicleForm.otherImage" :key="i">
                    <l-image
                      slot="activator"
                      :src="img.src"
                      :error="img.error"
                      :errorMessage="img.errorMessage"
                    >
                      <template slot="action">
                        <v-tooltip bottom>
                          <span>删除图像</span>
                          <v-btn slot="activator" @click="deleteImage(vehicleForm.otherImage, i)" icon>
                            <v-icon>$vuetify.icons.delete</v-icon>
                          </v-btn>
                        </v-tooltip>
                      </template>
                    </l-image>
                  </l-image-dialog>
                </v-flex>
                <v-flex xs12>
                  <l-select-file
                    @input="addFile(arguments[0], vehicleForm.otherImage)"
                    file-type="image/*"
                    title="添加图片"
                  >
                    <v-btn color="primary" flat slot="activator" :disabled="vehicleForm.otherImage.length===1||disabledFlag">
                      上传其他证明<span class="error--text caption" >（至多只上传一张图片）</span>
                    </v-btn>
                  </l-select-file>
                </v-flex>
              </v-layout>
              <v-layout justify-center >
                <v-btn class="primary" @click="submit" :loading="loading" :disabled="disabledFlag">提交</v-btn>
              </v-layout>
            </v-layout>
          </v-form>
        </v-card>
      </v-flex>
    </v-layout>
  </l-layout>
</template>
<script>
import LPlatePicker from '../../components/LPlatePicker'
import imageMixin from './imageMixin'
export default {
  name: 'vehicleBind',
  components: {
    LPlatePicker
  },
  mixins: [imageMixin],
  created () {
    this.dealPermission()
  },
  data () {
    return {
      disabledFlag: false,
      loading: false,
      hasSpecialPermission: false,
      vehicleForm: {
        typeSelect: [
        ],
        type: '',
        plate: '',
        driverLicense: [],
        vehicleLicense: [],
        otherImage: [],
        groupSelects: [],
        group: '',
        driver: ''
      }
    }
  },
  methods: {
    async  dealPermission () {
      let permission = await this.$store.dispatch('login/getPermission')
       console.log(permission)
      if (permission.vehicle !== undefined && permission.vehicle.specialRegister !== undefined) {
        this.hasSpecialPermission = true
      }
      if (permission.vehicle !== undefined && permission.vehicle.user !== undefined) {
        this.vehicleForm.typeSelect.push({
          value: 'per_ve',
          text: '校内用户车辆'
        })
      }
      if (permission.vehicle !== undefined && permission.vehicle.org !== undefined) {
        this.vehicleForm.typeSelect.push({
          value: 'org_ve',
          text: '校内用户车辆'
        })
      }
      if (permission.vehicle !== undefined && permission.vehicle.partner !== undefined) {
        this.vehicleForm.typeSelect.push({
          value: 'coo_ve',
          text: '合作用户车辆'
        })
      }
      if(this.vehicleForm.typeSelect.length!==0){
        this.vehicleForm.type = this.vehicleForm.typeSelect[0].value
      }
    },
    deleteImage (target, i) {
      target.splice(i, 1)
    },
    async addFile (file, target) {
      // file 实际上为fileList
      let imageCheckType = ['jpg', 'jpeg', 'png', 'gif']
      let IMAGE_MAX_SIZE = 5 * 1000 * 1000
      for (let f of file) {
        let checkType = imageCheckType
        let maxSize = IMAGE_MAX_SIZE
        // console.log('get file', f)
        let suffix = /\.([^.]*)$/i.exec(f.name)[1]
        if (checkType.indexOf(suffix) === -1) {
          this.$L.error({
            title: '上传文件格式错误',
            message: `上传格式: ${suffix}, 支持的格式: ${checkType.join(',')}`
          })
          return
        }
        else if (f.size > maxSize) {
          this.$L.error({
            title: '文件容量过大',
            message: `文件大小: ${Math.round(f.size / 1000)}KB, 最大限制: ${Math.round(maxSize / 1000)}KB`
          })
          return
        }
      }

      let temp = new Image()
      temp.loading = true
      if (target instanceof Array) {
        // 上传图片
        let img = await this.uploadFile(file)
        target.push(temp)
        this.$set(target, target.length - 1, img)
        // console.log(this.vehicleForm.driverLicense)
        this.getImg(img)
      }
    },
    async uploadFile (files) {
      if (files instanceof Object && files.length > 0) {
        let file = files[0]
        let img = new Image()
        // console.log(img)
        try {
          let res = await this.$store.dispatch('uploadFile', {file, url: '/passApi/check/file'})
          img.url = res
        }
        catch (e) {
          img.error = true
          img.errorMessage = e.message
        }
        return img
      }
    },
    async getGroups (data) {
      let search = (data === undefined) ? '' : data.target.value
      let pagination = {page: 0, rowsPerPage: 10}
      let param = {
        'searchParam': {
          'name': {
            'index': '1',
            'order': 'DESC',
            'operators': [
              {
                'keyword': search,
                'operator': 'LIKE',
                'matchType': 'BOTH'
              }
            ]
          }
        }
      }
      let res = await this.$store.dispatch('reservationConfig/getGroups', {param: param, pagination: pagination})
      if (res.data.status === 1) {
        this.vehicleForm.groupSelects = res.data.data.content
      }
      else {
        this.vehicleForm.groupSelects = []
      }
    },
    checkForm () {
      if (this.$refs.vehicleForm.validate()) {
        if (this.vehicleForm.driverLicense.length === 0 && this.vehicleForm.type === 'per_ve' && !this.hasSpecialPermission) {
          this.$L.alert('error', {message: '未上传传驾驶证'})
          return false
        }
        else if (this.vehicleForm.vehicleLicense.length === 0 && this.vehicleForm.type === 'per_ve' && !this.hasSpecialPermission) {
          this.$L.alert('error', {message: '未上传行驶证'})
          return false
        }
        else {
          return true
        }
      }
      else {
        this.$L.alert('error', {message: '表单数据不合法'})
        return false
      }
    },
    async submit () {
      if (this.checkForm()) {
        let extend = (this.vehicleForm.type === 'per_ve') ? {
          pic: [
            {name: '驾驶证', url1: (this.vehicleForm.driverLicense.length === 0) ? '' : this.vehicleForm.driverLicense[0].url || ''},
            {name: '行驶证', url2: (this.vehicleForm.vehicleLicense.length === 0) ? '' : this.vehicleForm.vehicleLicense[0].url || ''},
            {name: '其他证明', url3: (this.vehicleForm.otherImage.length === 0) ? '' : this.vehicleForm.otherImage[0].url}
          ],
          msg: ''
        } : ''
        let param = {}
        if (this.hasSpecialPermission) {
          param = {
            'plateNumber': this.vehicleForm.plate,
            'email': '',
            'phone': '',
            'groupId': this.vehicleForm.group,
            'checkType': this.vehicleForm.type,
            'objectCheckInfo': (this.vehicleForm.type === 'per_ve') ? JSON.stringify(extend) : '',
          }
          console.log(param)
        }
        else {
          param = {
            'plateNumber': this.vehicleForm.plate,
            'email': '',
            'phone': '',
            'groupId': this.vehicleForm.group,
            'checkType': this.vehicleForm.type,
            'objectCheckInfo': (this.vehicleForm.type === 'per_ve') ? JSON.stringify(extend) : ''
          }
        }
        this.loading = true
        let res = await this.$store.dispatch('vehicleRegister/vehicleBind', {param: param, owner: (this.hasSpecialPermission) ? this.vehicleForm.driver.id : ''})
        this.loading = false
        if (res.data.status === 1) {
          this.$L.alert('success', {message: '提交成功'})
          this.disabledFlag = true
          if (this.hasSpecialPermission) {
            this.reviewVehicle(res.data.data)
          }
        }
        else {
          this.$L.alert('error', {message: '提交失败，原因：' + res.data.msg})
        }
      }
    },
    async reviewVehicle (data) {
      let res = await this.$store.dispatch('vehicleRegister/reviewVehicle', {result: 'true', id: data.id, comment: ''})
      if (res.data.status === 1) {
        this.$L.alert('success', {message: '自动审核完成'})
      }
      else {
        this.$L.alert('error', {message: '自动审核失败，原因:' + res.data.msg})
      }
    },
    async searchUsers (val) {
      try {
        let {items} = await this.$store.dispatch('userAdmin/getUsers', {
          pagination: {page: 1, rowsPerPage: 100},
          search: {key: 'name', value: val},
        })
        return items
      }
      catch (e) {
        this.$L.alert('error', {message: e.message})
        return []
      }
    },
  }
}
</script>
